import Snackbar from "@material-ui/core/Snackbar"
import { withStyles } from "@material-ui/core/styles"
import withWidth from "@material-ui/core/withWidth"
import { initScreen } from "actions/screen"
import PubNubReact from "pubnub-react"
import React, { Component } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router"
import { compose } from "recompose"
import { closeSnackBar } from "../../actions/snack-bar"
import Router from "../../routes"
import PubNub from "../../services/pubnub"
import styles from "./styles"

class App extends Component {

  constructor() {
    super()
    this.pubnub = new PubNubReact({
      publishKey: process.env.REACT_APP_PUBNUB_PUBLISH_KEY,
      subscribeKey: process.env.REACT_APP_PUBNUB_SUBSCRIBE_KEY,
      uuid: "newScreen",
      heartbeatInterval: 10,
      presenceTimeout: 15,
      ssl: true
    })
    this.pubnub.init(this)
    PubNub.init(this.pubnub)
  }
  componentDidMount() {
    this.props.dispatch(initScreen())
    this.pubnub.setUUID(this.props.screen.id)
  }
  render() {
    const { classes } = this.props
    const snackBarOrigin =
      this.props.width === "sm" || this.props.width === "xs"
        ? { vertical: "bottom", horizontal: "left" }
        : { vertical: "bottom", horizontal: "left" }
    return (
      <div className={classes.app}>
        {/* REMOVE THIS CONTENT */}
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100%"
          }}
        >
          <Router />
        </div>
        <div id="dialog-holder">
          {/* LEAVE THIS IN PLACE FOR DIALOGS TO POPULATE INTO */}
        </div>
        <Snackbar
          anchorOrigin={snackBarOrigin}
          open={this.props.snackBar.open}
          onClose={() => this.props.dispatch(closeSnackBar())}
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          autoHideDuration={this.props.snackBar.autoHideDuration}
          message={<span id="message-id">{this.props.snackBar.message}</span>}
        />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    snackBar: state.snackBar,
    screen: state.screen.screen
  }
}

export default withRouter(
  compose(
    connect(mapStateToProps),
    withStyles(styles),
    withWidth()
  )(App)
)



// WEBPACK FOOTER //
// ./src/components/App/index.jsx